// extracted by mini-css-extract-plugin
export default {"box":"manager-avatar_box__ObXt7","dragger":"manager-avatar_dragger__5KXPW","close":"manager-avatar_close__1wGbc","text":"manager-avatar_text__CQvzY"};